import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  PRIZE_LIBRARY_ADD_PATH,
  PRIZE_LIBRARY_PATH,
  PRIZE_LIBRARY_UPDATE_PATH,
} from "utils/constants/paths";

const PrizeLibrary = Loadable(React.lazy(() => import("./View")));
const PrizeLibraryAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const PrizeLibraryRoute: IRouteItem = {
  path: PRIZE_LIBRARY_PATH,
  iconName: "Gift",
  element: React.createElement(PrizeLibrary),
  name: "Prize Library",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: PRIZE_LIBRARY_ADD_PATH,
      element: React.createElement(PrizeLibraryAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: PRIZE_LIBRARY_UPDATE_PATH,
      element: React.createElement(PrizeLibraryAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
